//import { ROUTER_DID_CHANGE } from 'redux-router/lib/constants';

export const CROSS_DOMAIN_NAVIGATION = 'global/CROSS_DOMAIN_NAVIGATION';
export const SET_CANONICAL_PATH = 'global/SET_CANONICAL_PATH';
export const STATUS_CODE = 'global/STATUS_CODE';
const ALERT_ADD = 'alert/ADD';
const ALERT_ROTATE = 'alert/ROTATE';
const EVENT = 'app/EVENT';
const EVENT_SUCCESS = 'app/EVENT_SUCCESS';
const EVENT_FAIL = 'app/EVENT_FAIL';
const NOTIFICATION_LOG = 'app/NOTIFICATION_LOG';
const NOTIFICATION_LOG_SUCCESS = 'app/NOTIFICATION_LOG_SUCCESS';
const NOTIFICATION_LOG_FAIL = 'app/NOTIFICATION_LOG_FAIL';

export const initialState = {
  statusCode: 200,
  canonical: {},
  alerts: []
};

export default function app(state = initialState, action) {
  if (action.type === STATUS_CODE) {
    return {
      ...state,
      statusCode: action.payload
    };
  }
  if (action.type === SET_CANONICAL_PATH) {
    return {
      ...state,
      canonical: {
        ...state.canonical,
        path: action.payload
      }
    };
  }
  if (action.type === ALERT_ROTATE) {
    const alerts = (state.alerts || [])
      .filter(item => item.views > 0)
      .map(item => {
        item.views--;
        return item;
      });
    return {
      ...state,
      alerts
    };
  }
  if (action.type === ALERT_ADD) {
    const alerts = state.alerts || [];
    alerts.push(action.payload);
    return {
      ...state,
      alerts
    };
  }

  return state;
}

export function crossDomainNavigation() {
  return { type: CROSS_DOMAIN_NAVIGATION };
}

export function setStatusCode(value) {
  return { type: STATUS_CODE, payload: value };
}

export function setCanonicalPath(payload) {
  return { type: SET_CANONICAL_PATH, payload };
}

export function addAlert(payload) {
  return { type: ALERT_ADD, payload };
}

export function rotateAlerts() {
  return { type: ALERT_ROTATE };
}

export function event(data) {
  return {
    types: [EVENT, EVENT_SUCCESS, EVENT_FAIL],
    promise: client => client.post('/api/event', { data })
  };
}

export function notificationLog(data) {
  return {
    types: [NOTIFICATION_LOG, NOTIFICATION_LOG_SUCCESS, NOTIFICATION_LOG_FAIL],
    promise: client => client.post('/api/notificationLog', { data })
  };
}

//alert: state.alert.filter(item => item.lifeTime > 0).map(item => item.lifeTime--)
